import RoundImage from "./RoundImage";
import ExpandOnHover from "./ExpandOnHover";
export default function ResourceCard({ name, imageUrl }) {
  const style = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  };
  return (
    <ExpandOnHover>
      <div className="card py-2 is-clickable" style={{ borderRadius: "8%" }}>
        <div style={style} className="card-image">
          <RoundImage imageUrl={imageUrl} />
        </div>
        <div className="card-content">
          <div className="media has-text-centered">
            <div className="media-content">
              <p className="title is-4">{name}</p>
              {/* <p className="subtitle is-6"># Getting Started</p> */}
            </div>
          </div>
        </div>
      </div>
    </ExpandOnHover>
  );
}
